import { css } from '@emotion/css';

import { Color, Font, FontWeight, ScreenBreakpoint, Spacing } from '../../../styles';

export const radioWrapper = css`
  margin-right: 0px !important;
  > span {
    padding-right: 0px !important;
  }

  .ant-radio-inner {
    width: 16px;
    height: 16px;

    &::after {
      width: 16px;
      height: 16px;
    }
  }

  .ant-radio {
    ${Font.md}
    ${FontWeight.semibold}
    color: ${Color.Brand6};

    @media (max-width: ${ScreenBreakpoint.mobile.max}) {
      ${Font.sm}
    }
  }
`;

export const labelWrapper = css`
  ${Font.md}
  ${FontWeight.semibold}
  color: ${Color.Brand6};

  @media (max-width: ${ScreenBreakpoint.mobile.max}) {
    ${Font.sm}
  }
`;

export const label = css`
  ${Font.lg}
  ${FontWeight.bold}
  ${Spacing.mb12}
`;

export const labelDisableWrapper = css`
  ${Font.md}
  ${FontWeight.semibold}
  color: ${Color.Gray4};
`;
